"use strict";
import ApiService from "../services/api_service";
import FactorInvoicesStore from "../stores/factor_invoices_store";
import DataStoreService from "./data_store_service";
var FactorInvoicesService = function() {
  var store = FactorInvoicesStore;
  var inFlight = {};
  this.ready = function() {
    var q = $.Deferred();
    q.resolve();
    return q.promise();
  };
  this.getWithId = function(id) {
    var existing = store.index[id];
    if (existing) {
      return Promise.resolve(store.index[id]);
    } else {
      return this.fetchWithIDAndReturnPromise(id);
    }
  };
  this.fetchInvoiceAndRelated = (id) => {
    return this.fetchWithID(id).then(
      ({
        factor_invoice: factorInvoice,
        factor_invoices: factorInvoices,
        verification,
        debtor_verification_status: debtorVerificationStatus
      }) => ({ factorInvoice, factorInvoices, verification, debtorVerificationStatus })
    );
  };
  this.getFetchedWithId = function(id) {
    return store.index[id];
  };
  this.fetchWithID = (id) => {
    if (inFlight[id]) {
      return inFlight[id];
    }
    const promise = ApiService.addErrorHandler(
      $.ajax({
        url: "/api/factor_invoices/" + id,
        cache: false,
        method: "GET"
      }).then(DataStoreService.responseHandler, _.identity).then((data) => {
        inFlight[id] = void 0;
        return data;
      })
    );
    inFlight[id] = promise;
    return promise;
  };
  this.fetchWithIDAndReturnPromise = function(id) {
    return this.fetchWithID(id).then((data) => data.factor_invoice);
  };
  this.rejectInvoice = (invoiceId) => {
    return ApiService.addErrorHandler(
      $.post(
        "/api/accounts_payable/factor_invoices/reject",
        { factor_invoices: [invoiceId] }
      ).then(DataStoreService.responseHandler, _.identity).then((data) => _.first(data.factor_invoices))
    );
  };
  this.unapproveInvoice = (invoiceId) => {
    return ApiService.addErrorHandler(
      $.post(
        "/api/accounts_payable/factor_invoices/unapprove_invoices",
        { factor_invoice: invoiceId }
      ).then(DataStoreService.responseHandler, _.identity).then((data) => _.first(data.factor_invoices))
    );
  };
  this.markInvoiceAsPurchased = (invoiceId) => {
    return ApiService.addErrorHandler(
      $.post(
        "/api/accounts_payable/factor_invoices/mark_as_purchased",
        { factor_invoice: invoiceId }
      ).then(DataStoreService.responseHandler, _.identity).then((data) => _.first(data.factor_invoices))
    );
  };
};
var factorInvoicesService = new FactorInvoicesService();
export default factorInvoicesService;
